import logEvent from 'analytics/logEvent';
import cn from 'classnames';
import { useRouter } from 'next/router';
import React from 'react';

import ALink from 'components/basic/ALink';
import Icon, { IconTypes } from 'components/basic/Icon';
import DesktopMenu from 'components/layouts/Header/DesktopMenu';

import { useAppDispatch } from 'redux-store';
import { openModal } from 'redux-store/slices/ui';

import Logo from './img/logo.svg';

import s from './Header.module.scss';

interface Props {
  className?: string;
  hideLink?: boolean;
  withoutLogo?: boolean;
}

const Header: React.FC<Props> = ({ hideLink, className, withoutLogo }) => {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const isCompact = !!router.query.compact;

  let logo = <div />;

  if (!withoutLogo) {
    logo =
      hideLink || isCompact ? (
        <Logo />
      ) : (
        <ALink href="/" className={s.logoLink}>
          <Logo />
        </ALink>
      );
  }

  return (
    <header className={cn(s.wrapper, className)}>
      {logo}

      {isCompact ? null : (
        <Icon
          icon={IconTypes.burger}
          color="white"
          size={24}
          onClick={(): void => {
            logEvent('Web_Header_Menu_Button_Clicked');
            dispatch(openModal({ type: 'MobileMenu' }));
          }}
          className={cn(s.mobileMenuButton, 'cy-mobile-profile-menu')}
        />
      )}

      <DesktopMenu />
    </header>
  );
};

export default Header;
